import App from "./app.ts";
import { mount } from "./alien-singui.ts";
mount(document.getElementById("root")!, App);
